module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=favicon.ico!./app/static/favicon.ico
 ** module id = 927
 ** module chunks = 0
 **/